import React from 'react';
import styles from './Characteristics.module.css'

const ConsoleItem = ({image, gameLibrary, Support, ssdVolume, resolution, gamepadsQuantity, name, openModal}) => {
    return (
        <>
            <div className={styles.content}>
                <h2>{name}</h2>
                <div className={styles.row}>
                    <div>
                        <ul className={styles.left_info}>
                            <li className={styles.first_li}>
                                <h3>Геймпади в комплекті</h3>
                                <p>{gamepadsQuantity}</p>
                            </li>
                            <li>
                                <h3>Підтримка зворотної сумісності</h3>
                                <p>{Support}</p>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <img className={styles.img} src={image} alt=""/>
                        <ul className={styles.center_info}>
                            <li>
                                <h3>Ігрова бібліотека</h3>
                                <p>{gameLibrary}</p>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <ul className={styles.right_info}>
                            <li className={styles.first_li}>
                                <h3>Роздільна здатність</h3>
                                <p>{resolution}</p>
                            </li>
                            <li>
                                <h3>Об'єм SSD/ Жорсткого диска</h3>
                                <p>{ssdVolume}</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className={styles.mobile_info_container}>
                    <ul>
                        <li>
                            <div>
                                <h3>Геймпади в комплекті</h3>
                                <p>{gamepadsQuantity}</p>
                            </div>
                        </li>
                        <li>
                            <div>
                                <h3>Підтримка зворотної сумісності</h3>
                                <p>{Support}</p>
                            </div>
                        </li>
                        <li>
                            <div>
                                <h3>Роздільна здатність</h3>
                                <p>{resolution}</p>
                            </div>
                        </li>
                        <li>
                            <div>
                                <h3>Ігрова бібліотека</h3>
                                <p>{gameLibrary}</p>
                            </div>
                        </li>
                        <li>
                            <div>
                                <h3>Об'єм SSD/ Жорсткого диска</h3>
                                <p>{ssdVolume}</p>
                            </div>
                        </li>
                    </ul>
                    <div style={{textAlign: 'center'}}>
                        <button onClick={() => openModal()} className={styles.btn}>Спробувати</button>
                    </div>
                </div>
            </div>
        </>
    )
        ;
};

export default ConsoleItem;
